import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import Menu from "../menu";
import ReactSelect from "react-select";
import {
  Table,
  Pagination,
  Button,
  Select,
  Input,
  DatePicker,
} from "../../components";
import { axios, Globals, Colors, Constants } from "../../utils";
import PrinterIcon from '../../assets/icons/printer.png';
import './inventory-changes.css';

const SELECT_USER_STYLES = {
  control: (base, state) => ({
    ...base,
    minHeight: '40px',
    height: '40px',
    borderColor: state.isFocused ? '#0b50ff' : 'gray',
    borderRadius: '5px',
    backgroundColor: '#ffffff',
    boxShadow: state.isFocused ? '0 0 0 1px #0b50ff' : 'none',
    fontSize: '13px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#0b50ff',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    height: '38px',
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center',
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: '#24477f',
    fontSize: '13px',
  }),
  singleValue: (base) => ({
    ...base,
    color: '#24477f',
    fontSize: '13px',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#94a3b8',
    fontSize: '13px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    color: state.isFocused ? '#0b50ff' : '#526b9b',
    padding: '6px 8px',
    '&:hover': {
      color: '#0b50ff',
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: '6px 4px',
    color: '#94a3b8',
    cursor: 'pointer',
    '&:hover': {
      color: '#ed2948',
    },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '8px',
    border: '1px solid #cfe0f4',
    boxShadow: '0 8px 24px rgba(16, 53, 127, 0.15)',
    zIndex: 99999,
    overflow: 'hidden',
    marginTop: '4px',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 99999,
  }),
  menuList: (base) => ({
    ...base,
    padding: '4px 0',
    maxHeight: '220px',
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '13px',
    padding: '9px 14px',
    cursor: 'pointer',
    backgroundColor: state.isSelected
      ? '#0b50ff'
      : state.isFocused
      ? '#f0f5ff'
      : '#ffffff',
    color: state.isSelected ? '#ffffff' : '#24477f',
    fontWeight: state.isSelected ? '600' : '400',
    '&:active': {
      backgroundColor: '#0b50ff',
      color: '#ffffff',
    },
  }),
};

const INITIAL_STATE = {
  since: '',
  until: '',
  product_id: '',
  warehouse_id: '',
  filter_user_id: '',
  category_id: '',
  brand_id: '',
  model_id: '',
  user_id: '',
  web: true,
  movement_type: '',
  showDeletedProducts: true,
  status: null,
  search: '',
  role: '',
  admin_id: '',
};

class InventoryChanges extends React.Component {
  constructor(props) {
    super(props);

    INITIAL_STATE.user_id = this.props.user.id;
    INITIAL_STATE.admin_id = this.props.user.admin_id || this.props.user.id;
    INITIAL_STATE.role = this.props.user.role;

    this.state = {
      header: [
        "Fecha y hora",
        "Producto",
        "Movimiento",
        "Documento",
        "Almacén origen",
        "Almacén destino",
        "Entrada",
        "Salida",
        "Existencia anterior",
        "Existencia final",
        "Usuario",
      ],
      data: [],
      warehouses: [],
      sellers: [],
      movement_types: [
        { value: '', label: 'Todos' },
        { value: '1.8', label: 'Modificación de stock' },
        { value: '9.5', label: 'Edición de pedido' },
        { value: 2, label: 'Venta' },
        { value: 3, label: 'Pedido rechazado' },
        { value: 6, label: 'Pedido cancelado' },
        { value: 4, label: 'Orden de compra' },
        { value: 7, label: 'Devolución de pedido' },
        { value: 11, label: 'Transferencia de almacén' },
      ],
      stats: {
        total: 0,
        entradas: 0,
        salidas: 0,
        transferencias: 0,
      },
      showFilters: true,
      page: 1,
      last_page: 1,
      loading: false,
      form: { ...INITIAL_STATE },
      dates: {
        minDate: "",
        maxDate: ""
      },
      searchTimeout: null,
    };
  }

  abortController = new AbortController();

  componentDidMount() {
    this.load();
    this.getWarehouses();
    this.getSellers();
  }

  componentWillUnmount() {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
    this.abortController.abort();
  }

  getWarehouses = () => {
    axios
      .post("web/admin/warehouses", {
        user_id: this.props.user.id,
        is_select: true,
        all_types: true,
        without_autosale: true,
        without_products: true,
      })
      .then(res => {
        if (res.data.warehouses) {
          const list = [
            { value: '', label: 'Todos los almacenes' },
            ...res.data.warehouses.map(item => ({
              value: item.id,
              label: item.name,
            }))
          ];
          this.setState({ warehouses: list });
        }
      })
      .catch(err => {
        console.log('Error cargando almacenes:', err);
      });
  };

  getSellers = () => {
    axios
      .post("web/admin/orders/sellers", {
        user_id: this.props.user.id,
        is_select: true,
        include_inactives: true,
      })
      .then(res => {
        const raw = Array.isArray(res.data)
          ? res.data
          : (res.data?.sellers?.data || res.data?.sellers || []);

        const list = raw.map(s => {
          const name = s.name || (s.first_name ? `${s.first_name} ${s.last_name || ''}`.trim() : s.email) || `Usuario #${s.id}`;
          const isAdmin = s.level_id === Constants.ROLE_ADMIN || s.level_id === 1;
          const label = isAdmin && !name.toLowerCase().includes('admin') ? `${name} (Admin)` : name;
          return {
            value: s.id,
            label: label,
          };
        });

        this.setState({ sellers: list });
      })
      .catch(err => {
        console.log('Error cargando usuarios:', err);
      });
  };

  load = () => {
    Globals.setLoading();
    let param = { ...this.state.form };
    param.user_id = this.props.user.id;

    axios
      .post("admin/reports/movements?page=" + this.state.page + '&minimize=true', param)
      .then(res => {
        if (res.data.movements) {
          this.setState({
            last_page: res.data.movements.last_page || 1,
            data: res.data.movements.data || [],
            stats: res.data.stats || this.state.stats,
          });
        }
      })
      .catch(err => {
        Globals.showError();
      })
      .then(() => {
        Globals.quitLoading();
      });
  };

  autoFilter = (isText = false) => {
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
    if (isText) {
      const searchTimeout = setTimeout(() => {
        this.setState({ page: 1 }, () => {
          this.load();
        });
      }, 700);
      this.setState({ searchTimeout });
    } else {
      this.setState({ page: 1 }, () => {
        this.load();
      });
    }
  };

  returnState = async () => {
    await this.setState(state => ({
      ...state,
      page: 1,
      form: {
        ...INITIAL_STATE
      },
      dates: {
        minDate: "",
        maxDate: ""
      },
    }));
    this.load();
  };

  print = () => {
    let param = { ...this.state.form };
    param.web = true;
    param.download = true;
    axios
      .post("admin/reports/movements", param)
      .then(res => {
        if (res.data.url) {
          const win = window.open(res.data.url, "_blank");
          if (win) win.focus();
        } else {
          Globals.showError('Ha ocurrido un error al generar el reporte');
        }
      })
      .catch(err => {
        Globals.showError();
      });
  };

  isEntrada = (item) => {
    const type = Number(item.movement_type_id);
    if ([3, 4, 6, 7].includes(type)) return true;
    if (type === 8 && Number(item.final_amount) > Number(item.current_amount)) return true;
    if (type === 11 && Number(item.final_amount) > Number(item.current_amount)) return true;
    return false;
  };

  isSalida = (item) => {
    const type = Number(item.movement_type_id);
    if ([1, 2, 9].includes(type)) return true;
    if (type === 8 && Number(item.final_amount) < Number(item.current_amount)) return true;
    if (type === 11 && Number(item.final_amount) < Number(item.current_amount)) return true;
    return false;
  };

  renderBadge = (item) => {
    const type = Number(item.movement_type_id);
    const entrada = this.isEntrada(item);

    switch (type) {
      case 2:
        return <span className="inv-badge inv-badge-sale">Venta</span>;
      case 11:
        return (
          <span className="inv-badge inv-badge-tr">
            {entrada ? "Transferencia · Entrada" : "Transferencia · Salida"}
          </span>
        );
      case 4:
        return <span className="inv-badge inv-badge-purchase">Compra</span>;
      case 3:
        return <span className="inv-badge inv-badge-rejected">Pedido rechazado</span>;
      case 6:
        return <span className="inv-badge inv-badge-canceled">Pedido cancelado</span>;
      case 7:
        return <span className="inv-badge inv-badge-warning">Devolución</span>;
      case 9:
      case 5:
        return <span className="inv-badge inv-badge-warning">Edición pedido</span>;
      case 1:
      case 8:
        return <span className="inv-badge inv-badge-gray">Modif. stock</span>;
      default:
        return <span className="inv-badge inv-badge-gray">{item.type?.name || 'Otro'}</span>;
    }
  };

  getDocumentRef = (item) => {
    if (item.order) {
      return 'N.E. ' + (item.order.number_format || item.order.correlative_number || item.order.id);
    }
    if (item.purchase) {
      return 'O.C. ' + (item.purchase.number_format || item.purchase.id);
    }
    if (item.transfer) {
      return 'TR. ' + String(item.transfer.id).padStart(4, '0');
    }
    return '—';
  };

  getOriginWarehouse = (item) => {
    const type = Number(item.movement_type_id);
    if (type === 11 && item.transfer) {
      return item.transfer.origin_warehouse?.name || '—';
    }
    return item.warehouse?.name || '—';
  };

  getDestinyWarehouse = (item) => {
    const type = Number(item.movement_type_id);
    if (type === 11) {
      if (item.transfer && item.transfer.destiny_warehouse) {
        return item.transfer.destiny_warehouse.name;
      }
      if (this.isEntrada(item)) {
        return item.warehouse?.name || '—';
      }
    }
    return '—';
  };

  render() {
    const { history } = this.props;
    const { data, header, stats, showFilters, warehouses, sellers } = this.state;
    const titleTable = 'Reporte de Movimientos de Inventario';

    return (
      <Menu history={history}>
        <div id="home" className="new-reports inv-container">
          <h1 className="inv-title">Movimientos de Inventario</h1>
          <div className="inv-subtitle">
            Consulta y audita las entradas, salidas y transferencias realizadas en cada almacén.
          </div>

          {/* Tarjetas de resumen (Stats) */}
          <div className="inv-stats">
            <div className="inv-stat-card">
              <div className="inv-stat-icon inv-icon-blue">▣</div>
              <div className="inv-stat-info">
                <div className="inv-stat-label">MOVIMIENTOS REGISTRADOS</div>
                <div className="inv-stat-val">{stats.total || 0}</div>
              </div>
            </div>
            <div className="inv-stat-card">
              <div className="inv-stat-icon inv-icon-green">↓</div>
              <div className="inv-stat-info">
                <div className="inv-stat-label">ENTRADAS</div>
                <div className="inv-stat-val">{stats.entradas || 0}</div>
              </div>
            </div>
            <div className="inv-stat-card">
              <div className="inv-stat-icon inv-icon-red">↑</div>
              <div className="inv-stat-info">
                <div className="inv-stat-label">SALIDAS</div>
                <div className="inv-stat-val">{stats.salidas || 0}</div>
              </div>
            </div>
            <div className="inv-stat-card">
              <div className="inv-stat-icon inv-icon-purple">⇄</div>
              <div className="inv-stat-info">
                <div className="inv-stat-label">TRANSFERENCIAS</div>
                <div className="inv-stat-val">{stats.transferencias || 0}</div>
              </div>
            </div>
          </div>

          {/* Filtros */}
          <div className="inv-filters">
            <div
              className="inv-filters-header"
              onClick={() => this.setState({ showFilters: !showFilters })}
            >
              <span>▽ &nbsp; Filtros</span>
              <span>{showFilters ? '▲' : '▼'}</span>
            </div>

            {showFilters && (
              <div className="inv-filters-body">
                <div className="inv-filter-item">
                  <DatePicker
                    color="white"
                    label="Desde"
                    className="filter"
                    minDate={this.state.dates.minDate}
                    value={this.state.form.since}
                    onChange={value => {
                      this.setState(state => ({
                        form: { ...state.form, since: value }
                      }), () => this.autoFilter(false));
                    }}
                  />
                </div>

                <div className="inv-filter-item">
                  <DatePicker
                    color="white"
                    label="Hasta"
                    className="filter"
                    maxDate={this.state.dates.maxDate}
                    value={this.state.form.until}
                    onChange={value => {
                      this.setState(state => ({
                        form: { ...state.form, until: value }
                      }), () => this.autoFilter(false));
                    }}
                  />
                </div>

                <div className="inv-filter-item">
                  <Input
                    color=" "
                    name="search"
                    label="Producto"
                    className="filter"
                    onChange={e => {
                      const val = e.target.value;
                      this.setState(state => ({ form: { ...state.form, search: val } }), () => {
                        this.autoFilter(true);
                      });
                    }}
                    value={this.state.form.search ?? ""}
                    placeholder="Nombre o código"
                    type="text"
                  />
                </div>

                <div className="inv-filter-item">
                  <Select
                    color="white"
                    label="Almacén"
                    className="filter"
                    disabledFirst={false}
                    name="warehouse_id"
                    options={warehouses}
                    value={this.state.form.warehouse_id}
                    onChange={e => {
                      const id = e.target.value;
                      this.setState(state => ({ form: { ...state.form, warehouse_id: id } }), () => {
                        this.autoFilter(false);
                      });
                    }}
                  />
                </div>

                <div className="inv-filter-item">
                  <Select
                    color="white"
                    label="Tipo de movimiento"
                    className="filter"
                    disabledFirst={false}
                    name="movement_type"
                    options={this.state.movement_types}
                    value={this.state.form.movement_type}
                    onChange={e => {
                      const id = e.target.value;
                      this.setState(state => ({ form: { ...state.form, movement_type: id } }), () => {
                        this.autoFilter(false);
                      });
                    }}
                  />
                </div>

                <div className="inv-filter-item">
                  <div className="form-group">
                    <label>Usuario</label>
                    <ReactSelect
                      className="inv-user-select"
                      classNamePrefix="inv-user-select"
                      styles={SELECT_USER_STYLES}
                      placeholder="Todos los usuarios"
                      isClearable={true}
                      isSearchable={true}
                      noOptionsMessage={() => "No se encontraron usuarios"}
                      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                      menuPosition="fixed"
                      options={sellers}
                      value={
                        sellers.find(
                          s => String(s.value) === String(this.state.form.filter_user_id)
                        ) || null
                      }
                      onChange={option => {
                        const id = option ? option.value : '';
                        this.setState(
                          state => ({ form: { ...state.form, filter_user_id: id } }),
                          () => {
                            this.autoFilter(false);
                          }
                        );
                      }}
                    />
                  </div>
                </div>

                <div className="inv-filter-buttons">
                  <button
                    type="button"
                    className="inv-btn-clear"
                    onClick={this.returnState}
                  >
                    Limpiar
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Tabla de Movimientos */}
          <Table
            data={data.length}
            title={titleTable}
            header={header}
            right={
              <Button
                title="Imprimir"
                small="true"
                onClick={this.print}
              >
                <img src={PrinterIcon} style={{ width: 22 }} alt="Imprimir" />
              </Button>
            }
          >
            {data.map((Item, index) => {
              const isTransfer = Number(Item.movement_type_id) === 11;
              const entrada = this.isEntrada(Item);
              const salida = this.isSalida(Item);
              const prod = Item.product || (Item.size_color && Item.size_color.product) || null;
              const prodText = prod ? (prod.code ? prod.code + ' ' : '') + prod.name : '—';

              return (
                <tr key={index} className={isTransfer ? "inv-trrow" : ""}>
                  {/* Fecha y hora */}
                  <td>{moment(Item.created_at).format('DD/MM/YYYY · HH:mm')}</td>

                  {/* Producto */}
                  <td>{prodText}</td>

                  {/* Movimiento badge */}
                  <td>{this.renderBadge(Item)}</td>

                  {/* Documento */}
                  <td style={{ whiteSpace: 'nowrap' }}>{this.getDocumentRef(Item)}</td>

                  {/* Almacén origen */}
                  <td>{this.getOriginWarehouse(Item)}</td>

                  {/* Almacén destino */}
                  <td>{this.getDestinyWarehouse(Item)}</td>

                  {/* Entrada */}
                  <td>
                    {entrada ? (
                      <span style={{ fontWeight: 600, color: '#087d5e' }}>{Item.movement_amount}</span>
                    ) : (
                      <span className="inv-empty-cell">—</span>
                    )}
                  </td>

                  {/* Salida */}
                  <td>
                    {salida ? (
                      <span style={{ fontWeight: 600, color: '#ed2948' }}>{Item.movement_amount}</span>
                    ) : (
                      <span className="inv-empty-cell">—</span>
                    )}
                  </td>

                  {/* Existencia anterior */}
                  <td>{Item.current_amount}</td>

                  {/* Existencia final */}
                  <td className="inv-final-amount">{Item.final_amount}</td>

                  {/* Usuario */}
                  <td>{Item.user?.name || '—'}</td>
                </tr>
              );
            })}
          </Table>

          {/* Paginación */}
          <Pagination
            pages={this.state.last_page}
            active={this.state.page}
            onChange={page => {
              this.setState({ page }, () => this.load());
            }}
          />
        </div>
      </Menu>
    );
  }
}

export default connect(state => {
  return {
    user: state.user
  };
})(InventoryChanges);
